import * as React from "react";

import { HTMLSelect } from "@blueprintjs/core";
import { ITopic } from "~/components/FAQ/types";
import styled from "~/styled";

interface IProps {
  topics: ITopic[];
  onChange: (topicKey: string) => any;
  value: string;
  placeholder: string;
}

const StyledHTMLSelect = styled(HTMLSelect)`
  @media (max-width: 375px) {
    select:first-child {
      font-size: 14px;
    }
  }

  @media (max-width: 320px) {
    select:first-child {
      font-size: 12px;
    }
  }
`;

export default class TopicSelector extends React.Component<IProps> {
  public render() {
    const { topics, value, placeholder } = this.props;

    return (
      <StyledHTMLSelect
        value={value || ""}
        large={true}
        onChange={this.handleChange}
      >
        <option value="" disabled={true}>
          {placeholder}
        </option>

        {topics.map(({ title, key }) => (
          <option key={key} value={key}>
            {title}
          </option>
        ))}
      </StyledHTMLSelect>
    );
  }

  private handleChange = (event: React.ChangeEvent<HTMLSelectElement>) =>
    this.props.onChange(event.currentTarget.value);
}



// WEBPACK FOOTER //
// ./src/components/FAQ/TopicSelector.tsx